import React, { useEffect } from "react"
import PropTypes from "prop-types"
import { connect } from "react-redux"

// component
import StackItem from "components/Stacker/components/StackItem/StackItem"
import Loader from "components/Stacker/components/Loader/Loader"

// actions
import { getProductStackDetails } from "components/Stacker/actions/StackItWithActions"

// Styles
import "./StackItWithModal.scss"
import { useSelector } from "react-redux"
import { useDispatch } from "react-redux"

function StackItWithModal() {
  const dispatch = useDispatch()
  const {
    pdp,
    stackItWith: {
      needCurrentStackPDPData,
      selectedStackedCodes,
      selectedBaseProductCodes,
    },
    cartMetaData,
    cartEntries,
    baseStore,
    isEPS,
    isCsAgent,
  } = useSelector((state) => {
    return {
      pdp: state.pdp,
      stackItWith: state.pdp.stackItWith,
      cartMetaData: state.cart.meta,
      cartEntries: state.cart.data.entries,
      baseStore: state.application.baseStore,
      isEPS: state.application.isEPS,
      isCsAgent: false,
    }
  })

  useEffect(() => {
    if (needCurrentStackPDPData) {
      const args = {
        baseStore,
        baseProductCodes: selectedBaseProductCodes.toString(),
        selectedStackedCodes,
      }

      dispatch(getProductStackDetails(args))
    }
  }, [needCurrentStackPDPData])

  const renderStackItem = () => {
    const stackedItemsDetails = selectedStackedCodes.map(
      (stackedVariantCode, index) => {
        const stackItem = pdp[stackedVariantCode]
        const { baseStore } = this.props

        return (
          <StackItem
            key={`stack-item-${index}`}
            baseStore={baseStore}
            stackedCode={stackedVariantCode}
            cartMetaData={cartMetaData}
            stackItem={stackItem}
            isEPS={isEPS}
            cartEntries={cartEntries}
            isCsAgent={isCsAgent}
          />
        )
      }
    )

    return stackedItemsDetails
  }

  if (!Object.keys(selectedStackedCodes).length || needCurrentStackPDPData) {
    return <Loader />
  }

  return (
    <div className="StackItWithModal" style={{ color: "black" }}>
      {renderStackItem()}
    </div>
  )
}

export default StackItWithModal
